import type { ReactNode } from "react";
import { Typography, Box, Skeleton, Chip } from "@mui/material";
import type { Poste } from "models";
import { grey } from "@mui/material/colors";

interface PosteBoxProps {
  poste: Partial<Poste>;
  isLoading?: boolean;
  noWrap?: boolean;
}

function IsVacantChip(): ReactNode {
  return (
    <Chip label="Vacant" variant="filled" color="warning" size="small" sx={{ marginRight: 1 }} />
  );
}

export function PosteBox({
  poste: { codeAstre, libelle, agent, isVacant = false },
  isLoading = false,
  noWrap = false,
}: Readonly<PosteBoxProps>): ReactNode {
  if (isLoading) {
    return <Skeleton />;
  }

  const occupeLibelle = isVacant ? "anciennement " : "occupé par ";

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <Typography noWrap={noWrap}>
        {libelle} {codeAstre}
        <br />
        {isVacant && <IsVacantChip />}
        <Typography component="span" sx={{ color: grey[500] }}>
          {occupeLibelle}
        </Typography>
        <Typography component="span" sx={{ color: "info.main", fontWeight: 500 }}>
          {agent?.nom} {agent?.prenom}
        </Typography>
      </Typography>
    </Box>
  );
}
